import { createClient } from "@supabase/supabase-js";

const projectURL = 'https://veuyiaukcipjpwxcexpa.supabase.co'
const projectKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZldXlpYXVrY2lwanB3eGNleHBhIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTk4NjUwNTcsImV4cCI6MjAxNTQ0MTA1N30.4h2eSr1sgyxK4bLGSkDUMn2I_mtnPLI__uJ7hgSfh88'

export const supabase = createClient(projectURL, projectKey);
